import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './assets/styles.scss';
import { assetIcons } from '../../config';
import { games } from '../../games/config';

const cx = classNames.bind(styles);
export default function MyBetsRow({
  result: {
    game_id: gameId,
    area,
    amount,
    balance: betAmount,
    asset,
    multiplier,
    winning_rate: payoutRate,
    payout,
    payout_balance: payoutBalance,
    winner,
    winner_player: isWin,
    game_result: result,
  },
  gameCode,
  className,
}) {
  let formattedPayoutRate;

  if (payoutRate) {
    formattedPayoutRate = `${payoutRate?.toFixed(2)}x`;
  } else if (multiplier && winner) {
    formattedPayoutRate = `${Number(multiplier)?.toFixed(2)}x`;
  } else {
    formattedPayoutRate = '0.00x';
  }

  const formattedArea = games[gameCode].formatPick(area);
  const formattedResult = games[gameCode].formatResult(result);
  const formattedPayout = payoutBalance || payout;
  const formmattedBetAmount = betAmount || amount;
  const formmattedIsWin = isWin === 'Y' || winner;

  return (
    <tr key={gameId} className={cx('small', className)}>
      <td>{gameId || '-'}</td>
      <td className={cx('bet-amount')}>
        <span className={cx('small')}>{betAmount || amount}</span>
        {assetIcons[asset]({})}
      </td>
      <td className={cx('hide-mobile')}>{formattedPayoutRate}</td>
      <td className={cx('hide-mobile')}>{formattedArea}</td>
      <td className={cx('hide-mobile')}>{formattedResult || '-'}</td>
      <td className={cx(formmattedIsWin ? 'win' : 'loss', 'bold')}>
        {formmattedIsWin ? formattedPayout : -formmattedBetAmount}
      </td>
    </tr>
  );
}

MyBetsRow.propTypes = {
  result: PropTypes.shape({
    game_id: PropTypes.number.isRequired,
    area: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    balance: PropTypes.number.isRequired,
    asset: PropTypes.string.isRequired,
    multiplier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    payout: PropTypes.number.isRequired,
    payout_balance: PropTypes.number.isRequired,
    winning_rate: PropTypes.number.isRequired,
    winner: PropTypes.bool.isRequired,
    winner_player: PropTypes.string.isRequired,
    game_result: PropTypes.string.isRequired,
  }),
  gameCode: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

MyBetsRow.defaultProps = {
  result: {},
};
